import React, { useMemo, useState } from 'react';
import { PolygonT } from 'bovaljaren-models';
import './Polygon.scss';
import { polygonMeasurements } from '../../PolygonPreview/PolygonPreview';
import { isMobile } from '../../../../utils/app.helper';
import { PolygonMeasurementsT } from '../mapping.helper';
type Props = {
    polygon: PolygonT;
    id?: string;
    className?: string;
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    inactive?: boolean;
    disablePolygonTouchInteraction: boolean;
};

const Polygon: React.FC<Props> = ({ polygon, inactive = false, className = '', id, onClick, onMouseEnter, onMouseLeave, disablePolygonTouchInteraction }): JSX.Element => {
    const [hover, setHover] = useState(false);
    const [touchStart, setTouchStart] = useState<React.TouchEvent>();

    const measure = useMemo((): PolygonMeasurementsT => {
        return polygonMeasurements(polygon);
    }, [polygon]);

    const onMouseOver = (): void => {
        !inactive && setHover(true);
        !inactive && onMouseEnter && onMouseEnter();
    };

    const onMouseOut = (): void => {
        !inactive && setHover(false);
        !inactive && onMouseLeave && onMouseLeave();
    };

    const onTouchEnd: React.TouchEventHandler<SVGPolygonElement> = (e): void => {
        if (disablePolygonTouchInteraction) return;

        const touchEnd = e.changedTouches[0];

        if (touchStart && e.timeStamp - touchStart?.timeStamp > 300) return;

        if (touchStart && Math.abs(touchEnd.clientX - touchStart.touches[0].clientX) > 10) return;

        if (touchStart && Math.abs(touchEnd.clientY - touchStart.touches[0].clientY) > 10) return;

        !inactive && onMouseEnter && onMouseEnter();
    };

    const onTouchStart: React.TouchEventHandler<SVGPolygonElement> = (e): void => {
        if (disablePolygonTouchInteraction) return;

        if (e.touches.length > 1) return;

        setTouchStart(e);
    };

    return (
        <polygon
            id={id}
            className={`bv-polygon ${ className } ${hover && !isMobile() ? 'bv-pop-animation' : ''}`}
            vectorEffect={'non-scaling-stroke'}
            style={{ transformOrigin: `${measure.xMid}% ${measure.yMid}%` }}
            onClick={inactive ? undefined : onClick}
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
            onMouseOver={isMobile() ? undefined : onMouseOver}
            onMouseOut={isMobile() ? undefined : onMouseOut}
            points={polygon.join(',')}/>
    );
};

export default Polygon;
